export class VirtualTerminalError extends Error {
	constructor(public userError: string) {
		super(userError);
	}
}

export function isVirtualTerminalError(error: VirtualTerminalError): error is VirtualTerminalError {
	return error.userError !== undefined;
}
